import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import OrderedProductReview from './OrderedProductReview'
import DeliveryPickAndPayment from './DeliveryPickAndPayment'
import {AppContext} from '../../../Context/AppContext'
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LinearProgress from '@mui/material/LinearProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({

    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },


    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    grow: {
        flexGrow: 1,
    },
    productListPaper: {

        marginBottom: 50,
    },
    productInformationTable:{
        padding:'.5rem'
    },

    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
      roota: {
          ...theme.typography.button,
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(1),
        },
    },

    radioGroup: {
        color: 'black', // Set the default color of the radio buttons
        '& .MuiRadio-root': {
          color: 'black', // Set the default color of the radio buttons
        },
        '& .Mui-focusVisible .MuiRadio-colorSecondary.Mui-checked': {
          color: 'green', // Set the color of the radio button when it is focused and checked
        },
        '& .MuiRadio-colorSecondary:hover': {
          color: 'red', // Set the color of the radio button when it is hovered
        },
    },

}));
  

const filter = createFilterOptions();

const Alert = React.forwardRef(function Alert(props, ref) {
return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
  

export default function ComputeReorder(props) {
    const classes = useStyles();
    const [searchProductTerm, setSearchProductTerm] = useState({name:""});
    const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
    const [openOrderedProductsReview, setOpenOrderedProductsReview] = useState(false)
    const [openDeliveryPickupAndPaymentDialog,setOpenDeliveryPickupAndPaymentDialog] = useState(false)
    const [showSettings, setShowSettings] = useState(false);
    const [targetInventoryLevel, setTargetInventoryLevel] = useState("1");
    const [isLoading,setIsLoading] = useState(true)
    const [loadProducts,setLoadProducts] = useState(true)
    const [pageNumber,setPageNumber] = useState(1)
    const [averageOffTakeFor, setAverageOffTakeFor] = useState("1");
    const [offtakeComputation, setOfftakeComputation] = useState("daily");
    const [unitOfMeasure, setUnitOfMeasure] = useState("smallest");
    const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
    const [products,setProducts] = useState([]);
    const [openReturnInformationReview, setOpenReturnInformationReview] = useState(false)
    const [open, setOpen] = useState(false);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [productsV2, setProductV2] = useState([]);
    const [count, setCount] = useState(1);
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [hasErrorFetchingProducts,setHasErrorFetchingProducts] = useState(false)
    const [settings, setSettings] = useState(false)
    const [error, setError] = useState(false)
    
    const [hasMoreProductToLoad, setHasMoreProductToLoad] =  useState(true);
    const lastProductElementObserver = useRef();
    const lastProductElement = useCallback(node => {

        if (isLoading) {return}
        if (lastProductElementObserver.current) {
            lastProductElementObserver.current.disconnect()
        }
        lastProductElementObserver.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreProductToLoad) {
                lastProductElementObserver.current.disconnect()
                setPageNumber(prevPageNumber => prevPageNumber + 1)
                setLoadProducts(true)
            }
        })
        if (node) lastProductElementObserver.current.observe(node)
    }, [isLoading, hasMoreProductToLoad])


    const handleCheckboxChange = (event) => {
        const { name, value } = event.target;
        
        if (name == "average-offtake-for") {
            setAverageOffTakeFor(value);
        }

        if (name == "offtake-computation") {
            setOfftakeComputation(value)
        }

        if (name == "unit-of-measure") {
            setUnitOfMeasure(value)
        }
        
    }
    
    const handleClickOpen = () => {
      setOpen(true);
      setShowSettings(true);
    };

    const handleReorderComputation = () => {

        if (targetInventoryLevel === "") {
            setError(true)
            return
        }

        setShowSettings(false);
        setSettings(true);
        setLoadProducts(true);
    }

    const handleClose = () => {

        if (error) {
            setError(false)
        } else {
            setOpen(false);
            setShowSettings(false);
        }
    };

    function closeAllDialog() {
        setOpenOrderedProductsReview(false)
        setOpenDeliveryPickupAndPaymentDialog(false)
    }
 
    useEffect(() => {

        if(!loadProducts){
          return
        }
        fetchProducts(searchProductTerm.name); 
    },[loadProducts, searchProductTerm.name, settings])

    useEffect(() => {

        function fetchAutoSuggestProducts(searchString){
      
          const loadProducts = async () => {
              
              setAutoCompleteSearchOptionMessage("Searching")
      
              const options = {
                method: 'POST',
                url: '/TransactiSellerProducts/getProductsForAutoSuggest.json',
                data: objectToFormData({search_term:searchString})
              }
                await axios(options)
                .then(res => {
                  
                  const products = res.data.products
                  if(products.length <= 0){
                    setAutoCompleteSearchOptionMessage("No record found.")
                    setAutoSuggestProducts([])
                  }else{
                    setAutoSuggestProducts(products)
                  }
                 
                });
            }
            loadProducts()
        }

        
        if(searchProductTerm == null){
            fetchAutoSuggestProducts("")
        }else{
            fetchAutoSuggestProducts(searchProductTerm.name)
        }

    }, [searchProductTerm]);

    const errorMessage = () => {
        return (
            <>
                <Stack spacing={2} sx={{ width: '100%' }}>
                <Snackbar open={error} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Target Inventory Level cannot be empty
                    </Alert>
                </Snackbar>
                </Stack>
            </>
        )
    }

    const fetchProducts = (searchTerm) => {
        setIsLoading(true) 
        setIsLoadingProducts(true);
        
        const options = {
            method: 'POST',
            url: '/TransactiSellerProducts/getTransactiComputedReorderQuantities.json',
            data: objectToFormData({
                search_term:searchTerm,
                page_number:pageNumber,
                average_offtake_for : averageOffTakeFor,
                offtake_computation : offtakeComputation,
                unit_of_measure : unitOfMeasure,
                target_inventory_level : targetInventoryLevel,
            })
        }
        axios(options)
        .then(res => {
            
            setIsLoading(false)
            setLoadProducts(false)
            setSettings(false)
            
            const isSuccess = res.data.response.is_success
            if(!isSuccess){
                setMessageDialogMessage(res.data.response.message)
                setShowMessageDialog(true)
                setHasErrorFetchingProducts(true)
            }

            const productsFromServer = res.data.response.products;
            setProducts(products.concat(productsFromServer));

        }).catch(error => {
            setSettings(false)
            setIsLoading(false) 
        })
    }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        
      return formData;
    }, new FormData());
    


    function autoComplete() {

        return (
            <Autocomplete
                value={searchProductTerm}
                noOptionsText={autoCompleteSearchOptionMessage}
                onChange={(event, newValue) => {

                    if(newValue==null || newValue.name===""){
                        searchProductTerm.name = ""
                        return
                    }

                    searchProductTerm.name = newValue.name
                    setProducts([])
                    setPageNumber(1)
                    setLoadProducts(true)
                }}
                
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={autoSuggestProducts}
                isOptionEqualToValue={(option, value) =>true}

                getOptionLabel={(option) => {
                   
                      return option.name;
                }}

                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.name}>
                      {option.name}
                    </li>
                  );
                }}

                style={{ width: '100%',paddingLeft:'8px'}}
                renderInput={(params) => (
                  <TextField
                   {...params}
                   variant='standard'  
                   InputProps={{...params.InputProps, disableUnderline: true}}  
                   
                  onChange={(event)=>{ 
                    setSearchProductTerm({name:event.target.value})
                  }
                  } />
                )}
            />
        )
    }
    
    function orderValue(unit) {
        return unit.order_quantity <= 0 ? '' : unit.order_quantity
    }

    function orderInput(product, unit) {
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    {/* <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography> */}
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        onChange={(event) => {

                        }}
                    />
                </Box>

            </Box>
        )
    }
    function search() {
        return (
            <div position="static" style={{ border: ".1rem solid #989898", borderRadius: "4px", margin: '2px' }}>
                <Toolbar variant="dense" style={{ padding: '0' }}>
                    <Box flexGrow={1}>{autoComplete()}</Box>
                    <Box>
                        <IconButton 
                            className={classes.margin} 
                            size="large"
                            onClick={()=>{
                                setProducts([])
                                setPageNumber(1)
                                setLoadProducts(true)
                            }}>
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </div>
        );
    }

    function productLists() {
        if (products.length != 0) {
            return (
                <List>
                    {
                        products.map((product, index) => (

                            (products.length === index + 1) ?
                                (
                                    <React.Fragment key={products.code}>
                                        <ListItem ref={lastProductElement} key={products.code+products.name} >
                                            {productElement(product)}
                                        </ListItem>
                                        <Divider light />
                                    </React.Fragment>
                                )
                            :
                                (
                                    
                                    <React.Fragment key={products.code}>
                                        <ListItem  key={products.code+products.name}>
                                            {productElement(product)}
                                        </ListItem>
                                        <Divider light />
                                    </React.Fragment>
                                )

                        ))
                    }
                </List>
            )

        }
    }
    
    function productElement(product) {
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                    < Grid item xs={3} md={2} lg={1} style={{ padding: "4px" }} container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                        <img src={product.image} alt={product.name} style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={9} md={10} lg={11}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.name}</Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} >
                    {productDataInformations(product)}
                </Grid>
                <Grid container direction="column" style={{marginTop:'.5rem'}} >
                    <Button variant="contained" color="primary">
                        Copy suggested order
                    </Button>
                </Grid>
                {/* <Grid container item xs={12} >
                        <Grid
                            container
                            direction="column">
                                {
                                    product.Units.map(unit => (
                                        <React.Fragment key={unit.id} >
                                            {orderInput(product, unit)}
                                        </React.Fragment>
                                    ))
                                }
                        </Grid>
                </Grid> */}
                <Grid item xs={9} md={10} lg={11}>
                    {/* <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "red" }}>Available: {product.available_inventory} {product.available_inventory_unit}</Grid>
                    <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>Total : P {product.total_order_value}</Grid> */}
                </Grid>            
            </Grid>
        );
    }

    function productDataInformations(product) {
        return (
            <TableContainer component={Paper} style={{padding:'0px',margin:'0px'}}>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                            <TableRow key={'ao'}>
                                <TableCell component="th" scope="row" className={classes.productInformationTable}>
                                    {'Ave Offtake ('+product.smallest_uom.uom+') per (Days)*'}
                                </TableCell>
                                <TableCell align="right" className={classes.productInformationTable}>{product.offtake}</TableCell>
                            </TableRow>
                            <TableRow key={'tild'}>
                                <TableCell component="th" scope="row" className={classes.productInformationTable}>
                                    {'Target Inventory Level (Days)*'}
                                </TableCell>
                                <TableCell align="right" className={classes.productInformationTable}>{product.target_inventory_level}</TableCell>
                            </TableRow>
                            <TableRow key={'til'}>
                                <TableCell component="th" scope="row" className={classes.productInformationTable}>
                                    {'Target Inventory Level ('+product.smallest_uom.uom+')*'}
                                </TableCell>
                                <TableCell align="right" className={classes.productInformationTable}>{product.target_inventory_level_quantity}</TableCell>
                            </TableRow>
                            <TableRow key={'ci'}>
                                <TableCell component="th" scope="row" className={classes.productInformationTable}>
                                    {'Current Inventory ('+product.smallest_uom.uom+')*'}
                                </TableCell>
                                <TableCell align="right" className={classes.productInformationTable}>{product.current_inventory}</TableCell>
                            </TableRow>
                            <TableRow key={'so'}>
                                <TableCell component="th" scope="row" className={classes.productInformationTable}>
                                    {'Suggested Order ('+product.smallest_uom.uom+')*'}
                                </TableCell>
                                <TableCell align="right" className={classes.productInformationTable}>{product.sugested_order}</TableCell>
                            </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    function underConstruction(){
        return(
            <h2>
              <center>  Under construction</center>
            </h2>
           
        )
    }
    function mainBody(){
        return(
            <React.Fragment>
                 <Paper square className={classes.productListPaper}>
                {search()}
                {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
                <CssBaseline /> 
                {productLists()}
            </Paper>
            <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                
                {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
                <CssBaseline /> 
                <Toolbar>
                    <Typography variant="subtitle1" noWrap>
                        Total : 4,718.00
                    </Typography>
                    <div className={classes.grow} />

                    <Button variant="contained" onClick={() => { setOpenOrderedProductsReview(true) }} >
                        <Typography variant="caption">
                            Add to cart
                            </Typography>
                        <Badge badgeContent={6} color="secondary" style={{ marginLeft: "1rem" }} />
                    </Button>


                </Toolbar>
            </AppBar>
            <OrderedProductReview openOrderedProductsReview={openOrderedProductsReview} setOpenOrderedProductsReview={setOpenOrderedProductsReview} setOpenDeliveryPickupAndPaymentDialog={setOpenDeliveryPickupAndPaymentDialog}/>
            <DeliveryPickAndPayment openDeliveryPickupAndPaymentDialog={openDeliveryPickupAndPaymentDialog} setOpenDeliveryPickupAndPaymentDialog={setOpenDeliveryPickupAndPaymentDialog} closeAllDialog={closeAllDialog}/>

            </React.Fragment>
        )
    }

    const settingsDialogue = () => {
        return (
            <div>
              <Dialog
                fullWidth={true}
                open={showSettings}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                </DialogTitle>

                <DialogContent>

                  <DialogContentText id="alert-dialog-description" >

                    <Box>
                        <FormControl >
                        <FormLabel style={{ color: 'black' }} id="average-offtake-for-radio-button">Average offtake for :</FormLabel>
                        <RadioGroup
                            className={classes.radioGroup}
                            aria-labelledby="average-offtake-for-radio-button"
                            defaultValue="1"
                            value={averageOffTakeFor}
                            name="average-offtake-for"
                            onChange={handleCheckboxChange}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="1 month" />
                            <FormControlLabel value="3" control={<Radio />} label="3 months" />
                            <FormControlLabel value="6" control={<Radio />} label="6 months" />
                            <FormControlLabel value="12" control={<Radio />} label="12 months" />
                        </RadioGroup>
                        </FormControl>
                    </Box>

                    <Box>
                        <FormControl>
                        <FormLabel style={{ color: 'black' }} id="offtake-computation-radio-button">Offtake computation : </FormLabel>
                        <RadioGroup
                            className={classes.radioGroup}
                            aria-labelledby="offtake-computation-radio-button"
                            defaultValue="daily"
                            value={offtakeComputation}
                            name="offtake-computation"
                            onChange={handleCheckboxChange}
                        >
                            <FormControlLabel value="daily" control={<Radio />} label="Daily" />
                            <FormControlLabel value="weekly" control={<Radio />} label="Weekly" />
                            <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
                        </RadioGroup>
                        </FormControl>
                    </Box>


                    <Box>
                        <FormControl>
                        <FormLabel style={{ color: 'black' }} id="unit-of-measure-radio-button">Unit of measure</FormLabel>
                        <RadioGroup
                            className={classes.radioGroup}
                            style={{ color: 'black' }} 
                            aria-labelledby="unit-of-measure-radio-button"
                            defaultValue="smallest"
                            value={unitOfMeasure}
                            name="unit-of-measure"
                            onChange={handleCheckboxChange}
                        >
                            <FormControlLabel value="smallest" control={<Radio />} label="Smallest" />
                            <FormControlLabel value="biggest" control={<Radio />} label="Biggest" />
                        </RadioGroup>
                        </FormControl>
                    </Box>

                    <Box marginTop={2} >
                        
                        <TextField
                            fullWidth={true}
                            InputLabelProps={{
                                style: {
                                    color: 'black'
                                },
                                focused: true
                            }}
                            InputProps={{ inputProps: { min: 1 } }}
                            style={{ color: 'black' }} 
                            id="filled-number"
                            label="Target Inventory level (days)"
                            type="number"
                            variant="standard"
                            value={targetInventoryLevel}
                            onChange={(e) => {
                                var value = e.target.value;
                                
                                if (value === '') {
                                    setTargetInventoryLevel('');
                                } else {
                                    const intValue = parseInt(value);
                                    const newValue = intValue === 0 ? 1 : intValue;
                                    setTargetInventoryLevel(newValue.toString());
                                }
                               
                            }}
                        />

                    </Box>
                
                  </DialogContentText>

                </DialogContent>

                <DialogActions>
                  <Button color="primary"  style={{ backgroundColor: 'white', color: '#1976d2' }} onClick={handleClose}>Close</Button>
                  <Button color="primary" style={{ backgroundColor: 'white', color: '#1976d2' }} onClick={handleReorderComputation} autoFocus>
                    Save
                  </Button>
                </DialogActions>

              </Dialog>
            </div>
          );
    }

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>

                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={props.handleDrawerToggle}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    
                    <Typography variant="subtitle1" noWrap>
                        Compute Reorder
                    </Typography>

                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>  
                        <Button color="inherit" style={{ float: 'right' }} onClick={handleClickOpen}>Setting</Button>
                     </Typography>
                   
                </Toolbar>
            </AppBar>
            { mainBody() }
            {error && errorMessage()}
            {settingsDialogue()}
            {/* {<ReturnProductsReview openReturnProductsReview={openReturnProductsReview} setOpenReturnProductsReview={setOpenReturnProductsReview} setOpenReturnInformationReview={setOpenReturnInformationReview}/>}
            {<ReturnInformationReview  openReturnInformationReview={openReturnInformationReview} setOpenReturnInformationReview={setOpenReturnInformationReview}  closeAllDialog={closeAllDialog}/>} */}

        </div>
    );

}